import { ReactElement } from 'react';

import { ChakraBox, ChakraTabPanel, ChakraTabPanels } from '@equip.health/ui';

import { ProfileTab } from '~/lib/util/profile.util';

import ProfileCalendar from './ProfileCalendar';
import ProfileInfo from './ProfileInfo';
const TOP_LEVEL_ID = 'profile__tabs__panels';

const ProfilePanel = () => {
  const ProfileTabsMap: Record<ProfileTab, React.ReactElement> = {
    [ProfileTab.PROFILE]: <ProfileInfo />,
    [ProfileTab.CALENDAR]: <ProfileCalendar />,
  };

  return (
    <ChakraBox height="100%" overflow="auto">
      <ChakraTabPanels height="100%" id={TOP_LEVEL_ID}>
        {Object.entries(ProfileTabsMap).map(
          ([tab, TabComponent]: [string, ReactElement]) => (
            <ChakraTabPanel id={`${TOP_LEVEL_ID}-${tab}`} key={tab} padding={0}>
              {TabComponent}
            </ChakraTabPanel>
          ),
        )}
      </ChakraTabPanels>
    </ChakraBox>
  );
};

export default ProfilePanel;
